import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const VerifyEmailPage = () => {
    const { token } = useParams();
    const navigate = useNavigate();
    const [verificationStatus, setVerificationStatus] = useState({
        loading: true,
        success: false,
        message: ''
    });

    useEffect(() => {
        const verifyEmail = async () => {
            try {
                if (!token) {
                    setVerificationStatus({
                        loading: false,
                        success: false,
                        message: 'Invalid verification link.'
                    });
                    return;
                }

                // Use the correct API endpoint
                const apiUrl = `https://api.interstellarmap.com/verify-email/${token}`;
                console.log('Making verification request to:', apiUrl);

                const response = await axios.get(apiUrl);
                console.log('Verification response:', response.data);

                if (response.data.success) {
                    setVerificationStatus({
                        loading: false,
                        success: true,
                        message: 'Email verified successfully! You can now log in to your account.'
                    });
                } else {
                    setVerificationStatus({
                        loading: false,
                        success: false,
                        message: response.data.message || 'Email verification failed'
                    });
                }
            } catch (error) {
                console.error('Email verification error:', error);
                setVerificationStatus({
                    loading: false,
                    success: false,
                    message: error.response?.data?.message || 'Verification failed. The link may be invalid or expired.'
                });
            }
        };

        verifyEmail();
    }, [token]);

    const handleLoginClick = () => {
        navigate('/');
        document.dispatchEvent(new CustomEvent('open-login-modal'));
    };

    return (
        <div className="min-h-screen bg-black flex items-center justify-center px-4">
            <div className="max-w-md w-full bg-gray-900 rounded-lg shadow-xl p-8 text-center">
                {verificationStatus.loading ? (
                    <div>
                        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-accent mx-auto mb-4"></div>
                        <h2 className="text-xl font-semibold text-white mb-2">
                            Verifying your email...
                        </h2>
                        <p className="text-gray-300">
                            Please wait while we verify your email address.
                        </p>
                    </div>
                ) : (
                    <div>
                        <div className={`w-16 h-16 mx-auto mb-4 rounded-full flex items-center justify-center ${verificationStatus.success ? 'bg-green-500' : 'bg-red-500'
                            }`}>
                            {verificationStatus.success ? (
                                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                                </svg>
                            ) : (
                                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                                </svg>
                            )}
                        </div>

                        <h2 className={`text-xl font-semibold mb-4 ${verificationStatus.success ? 'text-green-400' : 'text-red-400'
                            }`}>
                            {verificationStatus.success ? 'Email Verified!' : 'Verification Failed'}
                        </h2>

                        <p className="text-gray-300 mb-6">
                            {verificationStatus.message}
                        </p>

                        {verificationStatus.success ? (
                            <button
                                onClick={handleLoginClick}
                                className="bg-accent text-white px-6 py-3 rounded-lg font-semibold hover:bg-accent/90 transition-colors"
                            >
                                Go to Login
                            </button>
                        ) : (
                            <button
                                onClick={() => navigate('/')}
                                className="bg-gray-700 text-white px-6 py-3 rounded-lg font-semibold hover:bg-gray-600 transition-colors"
                            >
                                Return to Home
                            </button>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default VerifyEmailPage; 